<template>
  <div>
    <Head :title="form.vendorname" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/vendors">Vendors</Link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.vendorname }}
    </h1>
    <trashed-message v-if="vendor.deleted_at" class="mb-6" @restore="restore"> This vendor has been deleted. </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.vendorname" :error="form.errors.vendorname" class="pb-8 pr-6 w-full lg:w-1/2" label="vendorname" />
          <select-input v-model="form.contactuser" :error="form.errors.contactuser" class="pb-8 pr-6 w-full lg:w-1/2" label="User for Order Emails">
            <option value="0">--No Email Contact--</option>
            <template v-for="u in users">
              <option :value="u.id">{{u.email}} - {{u.last_name}}, {{u.first_name}}</option>
            </template>
          </select-input>
          <text-input v-model="form.phone" :error="form.errors.phone" class="pb-8 pr-6 w-full lg:w-1/2" label="Phone" />
          <text-input v-model="form.address" :error="form.errors.address" class="pb-8 pr-6 w-full lg:w-1/2" label="Address" />
          <text-input v-model="form.city" :error="form.errors.city" class="pb-8 pr-6 w-full lg:w-1/2" label="City" />
          <text-input v-model="form.region" :error="form.errors.region" class="pb-8 pr-6 w-full lg:w-1/2" label="Province/State" />
          <select-input v-model="form.country" :error="form.errors.country" class="pb-8 pr-6 w-full lg:w-1/2" label="Country">
            <option :value="null" />
            <option value="US">United States</option>
            <option value="CA">Canada</option>
            <option value="MX">Mexico</option>
          </select-input>
          <text-input v-model="form.postal_code" :error="form.errors.postal_code" class="pb-8 pr-6 w-full lg:w-1/2" label="Postal code" />
          <file-input v-model="form.logo" :error="form.errors.logo" class="pb-8 pr-6 w-1/2 " type="file" accept="image/*" label="Logo" />
          <div class="w-1/2">
            <h2 class="mb-4 font-bold">Purchase Order Types</h2>
            <div v-for="OrderType in OrderTypes" class="w-full pb-5">
              <label>
                {{ OrderType }}
                <input type="checkbox" class="ordertype" :name="OrderType" v-if="(form.ordertypes.indexOf(OrderType) >= 0)" checked="checked" />
                <input type="checkbox" class="ordertype" :name="OrderType" v-if="(form.ordertypes.indexOf(OrderType) < 0)" />

              </label>
            </div>
             <input type="hidden" v-model="form.ordertypes" />
          </div>
        </div>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <!--<button v-if="!jobsite.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Delete Jobsite</button>-->
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Update Vendor</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import FileInput from '@/Shared/FileInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import {
  OrderTypes,
} from "./../../../enums";

export default {
  components: {
    Head,
    Icon,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    FileInput,
  },
  layout: Layout,
  props: {
    jobsite: Object,
    vendor: Object,
    users: Object,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        vendorname: this.vendor.vendorname,
        //email: this.jobsite.email,
        contactuser: this.vendor.contactuser,
        phone: this.vendor.phone,
        address: this.vendor.address,
        city: this.vendor.city,
        region: this.vendor.region,
        country: this.vendor.country,
        postal_code: this.vendor.postal_code,
        ordertypes: (this.vendor.ordertypes || '[]'),
        logo: this.vendor.logo,
      }),
      OrderTypes,
    }
  },
  methods: {
    pickjobsite: (jid) => {
      document.cookie = 'jobsite=' + jid +';path=/;';
      try { window.setTimeout(function() { document.querySelector('#mainmenu .text-white').parentElement.click(); },1);
      } catch(e) { console.error(e); }
    },
    update() {
      var ordertypes = [];
      document.querySelectorAll('.ordertype').forEach(function(v) {
          if (v.checked) { ordertypes.push(v.name) }
      });
      this.form.ordertypes = ordertypes;
      this.form.put(`/vendors/${this.vendor.id}`)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this jobsite?')) {
        this.$inertia.delete(`/vendors/${this.vendor.id}`)
      }
    },
    restore() {
      if (confirm('Are you sure you want to restore this jobsite?')) {
        this.$inertia.put(`/vendors/${this.vendor.id}/restore`)
      }
    },
  },
}
</script>
